import { IControl4ContactsModel } from "@app/shared/shared.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const c4ContactsAdapter: EntityAdapter<(IControl4ContactsModel)> = createEntityAdapter<IControl4ContactsModel>({
	selectId: contacts => contacts.accountId
});